import { PageListColumnDirective } from './layout/column';
import { GridLayoutHeaderComponent } from './layout/header.component';
import { GridLayoutComponent } from './layout/layout.component';

export const GRID_DECLARATIONS: any[] = [
  GridLayoutComponent,
  GridLayoutHeaderComponent,
  PageListColumnDirective,
];
